/**
 * api接口统一管理
 */
import {axiosInstance,LoginAxiosInstance} from "./http";
//登录

export const getLoginQr = obj => LoginAxiosInstance.get('/blade-auth/oauth/captcha/mq',{params:obj})

export const checkLogin = (obj,config={}) => LoginAxiosInstance.post('/blade-auth/oauth/captcha/token',obj,config)

export const login = (obj,config={}) => LoginAxiosInstance.post('/blade-auth/oauth/token',obj,config)
//注册
export const register = (obj,config={}) => LoginAxiosInstance.post('/blade-user/register',obj,config)
//修改密码
export const findPassword = (obj,config={}) => LoginAxiosInstance.post('/blade-user/find-password',obj,config)
//发送验证码
export const sendMsgCode = (obj) => LoginAxiosInstance.post('/blade-resource/sms/endpoint/send-validate',obj)

//个人信息
export const userInfo = (obj) => axiosInstance.get('/blade-user/info',{params:obj})

//修改信息
export const updateUserInfo = (obj) => axiosInstance.post('/blade-user/update-info',obj)


/**
 * 查询学习情况
 * @param obj
 */
export const getMyStudyInfo = () => axiosInstance.get('/education-api/course/my-study-info')

/**
 * 用户拥有的证书
 * @param obj
 */
export const getCertificateMyList = () => axiosInstance.get('/blade-website/certificate/getMyList')

